import { useEffect, useState } from 'react';

const DEFAULT_FIAT_PROPERTY = "defaultFiat";

/**
 * props:
 * - fiat
 * - onChange
 */
function SelectFiat(props) {

    const [fiat, setFiat] = useState(getDefaultFiat());

    useEffect(() => {
        if (!props.fiat) return;
        setFiat(props.fiat);
    }, [props.fiat])

    return (
        <>
            <select id="selectFiat" className="form-select pe-6" value={fiat} onChange={props.onChange}>
                <option value="AUD">AUD</option>
                <option value="BRL">BRL</option>
                <option value="EUR">EUR</option>
                <option value="GBP">GBP</option>
                <option value="NGN">NGN</option>
                <option value="TRY">TRY</option>
                <option value="UAH">UAH</option>
                <option value="USD">USD</option>
            </select>
        </>
    )
}

export function getDefaultFiat() {
    return localStorage.getItem(DEFAULT_FIAT_PROPERTY) ? localStorage.getItem(DEFAULT_FIAT_PROPERTY) : "USD";
}

export function setDefaultFiat(quote) {
    localStorage.setItem(DEFAULT_FIAT_PROPERTY, quote);
}

const FIAT_ISO = {
    USD: 'USD', USDT: 'USD', USDC: 'USD', BUSD: 'USD',
    BRL: 'BRL', EUR: 'EUR', GBP: 'GBP', AUD: 'AUD',
    NGN: 'NGN', TRY: 'TRY', UAH: 'UAH'
};

export function toIsoCurrency(fiat) {
    const code = String(fiat || 'USD').toUpperCase();
    return FIAT_ISO[code] || 'USD';
}

export function formatFiatAmount(value, fiat) {
    const num = typeof value === 'number' ? value : parseFloat(String(value).replace(/[^\d.-]/g, ''));
    if (!Number.isFinite(num)) return '-';
    try {
        return num.toLocaleString('pt-BR', {
            style: 'currency',
            currency: toIsoCurrency(fiat),
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    } catch (_) {
        return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}

export default SelectFiat;
